import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/think-peaks': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M465.4 409.4l-206.2-353.8-204.2 352.1-32-0.3 236.2-407.4 206.2 353.9 55.1-95 32 0.3zM110.1 365.3l149.6-257.9 235.8 404.6-32.5-0.1-203.4-349.1-117.4 202.5h-32.1z'
      }
    ]
  }
})
